import API from "../../API/api";


export const GettingSubmission = async (problemRef,studentId, messageData) => {
  try {
    const response = await API.get(
      `/submission/${problemRef}/${studentId}`,
      messageData
    );
    return  { found: true, data: response.data };
  } catch (err) {
    if (err.response && err.response.status === 404) {
      console.warn("No submission under these credentials");
      return { found: false, data: null };
    }
    console.error("Error fetching submission:", err);
    throw err; // still throw if it's not a 404
  }
};

export const GettingSubmissions = async (studentId, messageData) => {
  try {
    const response = await API.get(
      `/submission/${studentId}`,
      messageData
    );
    return  { found: true, data: response.data };
  } catch (err) {
    if (err.response && err.response.status === 404) {
      console.warn("No submission under these credentials");
      return { found: false, data: null };
    }
    console.error("Error fetching submission:", err);
    throw err; // still throw if it's not a 404
  }
};

export const add2DiscussionMessage = async (problemRef, studentId, messageData) => {
  try {
    const response = await API.put(
      `/submission/${problemRef}/${studentId}/comment`,
      messageData
    );
    return response.data;
  } catch (err) {
    console.error("Error adding discussion message:", err);
    throw err;
  }
};


export const creatSubmissionSession = async (messageData) => {
  try {
    const response = await API.post(
      `/submission`,
      messageData
    );
    return response.data;
  } catch (err) {
    console.error("Error adding discussion message:", err);
    throw err;
  }
};

export const UpdateSubmission = async (problemRef, studentId , messageData) => {
  try {
      const response = await API.put(
        `/submission/${problemRef}/${studentId}`,
        messageData
      )
  }catch(err){
    console.error("Error updating submission Session", err)
    throw err;
  }
}

export const DeleteSession = async (problemRef, studentId , messageData) => {
  try {
      const response = await API.delete(
        `/submission/${problemRef}/${studentId}`,
        messageData
      )
  }catch(err){
    console.error("Error updating submission Session", err)
    throw err;
  }
}


/* export const GettingAll = async (config = {}) => {
  try {
    const response = await API.get(
      `/submission`,
      config // can contain headers, params, etc.
    );
    return response.data; // ✅ return the actual data
  } catch (err) {
    console.error("Error fetching submissions", err);
    throw err;
  }
}; */

export const GettingAll = async (page = 1, limit = 10) => {
  try {
    const response = await API.get(
      `/submission?page=${page}&limit=${limit}`
    );
    return response.data; // { submissions, total, page, totalPages }
  } catch (err) {
    console.error("Error fetching submissions", err);
    throw err;
  }
};



export const UpdateStudentProblemList = async (problemRef, studentId , messageData) => {
  try {
      const response = await API.delete(
        `/submission/${problemRef}/${studentId}`,
        messageData
      )
  }catch(err){
    console.error("Error updating submission Session", err)
    throw err;
  }
}

export const awardPointsToStudent = async ( studentId , messageData) => {
  try {
    console.log(messageData)
      const response = await API.post(
        `/Student/${studentId}/award`,
        messageData
      )
  }catch(err){
    console.error("Error updating submission Session", err)
    throw err;
  }
}




